import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const StreakBadge = styled.div`
    position: relative;
    height:100%;
    width:100%;
    display:grid;
    grid-template-rows: 0.8fr 1fr 3fr 0.5fr 0.8fr;
`;

export const PraiseRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    > span{
        font-size: clamp(16px, 1.4vw, 20px);
        font-weight: 500;
        text-align: center;
       
    }

    ${mq(Devices.mobile)}{
        > span{
            
            font-size: clamp(16px, 5.5vw, 24px);
        }
    }
`;

export const BadgeRow = styled.div<{small?:boolean}>`
    content: " ";
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:20px;
    z-index: 5;

    span{
        position: absolute;
        top: ${props => props.small?"53":"59"}%;
        left:50%;
        transform: translate(-50%, -50%);
        font-size: clamp(16px, 2vw, 38px);
        font-weight: 700;
        color:#fff;
    }

    svg {
        transform: unset !important;
    }

    ${mq(Devices.laptop)}{
        span{
            font-size: clamp(22px, 4vw, 38px);
        }
    }

    ${mq(Devices.tablet)}{
        span{
            font-size: clamp(22px, 3vw, 38px);
        }
    }

    ${mq(Devices.mobile)}{
        span{
            font-size: clamp(22px, 8vw, 38px);
        }
    }
    
`;

export const Badge = styled.div<{hide:boolean}>`
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    position: relative;
    transition: all 1.2s ease-in-out;
    transform: scale(${props => props.hide?"0":"1"});

    div{
        position: absolute;
        top:52%;
        left:51%;
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        z-index: 1;
        transform: translate(-50%, -50%);

        span{
            color:#fff;
            font-weight: 800;
            :nth-of-type(1){
                font-size: 30px;
                line-height: 28px;
            }
            :nth-of-type(2){
                font-size: 20px;
            }
        }

    }

    svg{
        width: 65%;
    }

    ${mq(Devices.tablet)}{
        height: 70%;
    }

    ${mq(Devices.mobile)}{
        height: 90%;
    }
`;


export const LevelRow = styled.div<{animate:boolean, numberAni?:number}>`
    display: flex;
    align-items: center;
    justify-content: center;    
    transition: all 0.5s ease-in-out;
    transform: scale(${props => props.animate?"1.5":"1"});
    overflow: hidden;
    height:30px;

    > span{
        font-size: clamp(12px, 4vw, 20px);
        font-weight: 700;
        transform-style: preserve-3d;
        margin-right: 6px;
        height:30px;
        line-height: 30px;
    }
`;

export const CounterUnit = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display' && prop !== 'roll',
})<{display?:boolean, roll?:boolean}>`
    display:${props => props.display?"none":"flex"};
    flex-direction: column;
    justify-content: start;

    transform: translateY(${props => props.roll?"-30px":"0"});
    transition: ${props => props.roll?"transform 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55)":"unset"};
    width:13px;
    height:30px;
`;

export const CounterNumber = styled.div<{}>`
    font-size: clamp(12px, 4vw, 20px);
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    width:13px;
`;

export const ExpRow = styled.div`
    content: " ";
    display:flex;
    align-items: center;
    justify-content: center;
`;

export const Bar = styled.div`
    background:#fff;
    content: " ";
    height:30px;
    width:80%;
    border-radius: 50px;
    border:3px solid #2A848E;
    position: relative;
    overflow:hidden;
    
    span{
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        font-weight: 800;
        z-index: 3;
        color:#000;
    }
`;

export const Fill = styled.div<{fill:number, time:number}>`
    background:linear-gradient(0deg, #3dbcca 40%, #29edff 100%);
    content: " ";
    width: ${props => props.fill?props.fill:"0"}%;
    height:100%;
    position: inherit;
    z-index: 2;
    transition: width ${props => props.time}ms ease-in-out;
    overflow: hidden;
`;
